// extracted by mini-css-extract-plugin
export var closeButton = "_14-3";
export var header = "_14-0";
export var link = "_14-1";
export var retryButton = "_14-2";